const TokelauSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112566)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M32.1739 9.56523C31.9945 10.4273 31.913 11.3455 31.913 12.2609C31.913 17.537 35.0583 22.1034 39.5657 24.1591C39.8495 22.8173 40 21.4263 40 20C40 8.95437 31.0456 0 20 0C8.95437 0 0 8.95437 0 20C0 31.0456 8.95437 40 20 40C26.8502 40 32.8952 36.5553 36.4997 31.3044H11.3044V28.6957H38.0155C38.2888 28.1304 38.5358 27.55 38.7561 26.9566H11.3044L32.1739 9.56523Z"
        fill="#0052B4"
      />
      <path
        d="M14.6934 10.4346L15.1251 11.7632H16.522L15.3919 12.5843L15.8237 13.9129L14.6934 13.0918L13.5633 13.9129L13.995 12.5843L12.8647 11.7632H14.2617L14.6934 10.4346Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.01861 20L9.5583 21.6609H11.3044L9.89166 22.687L10.4313 24.3478L9.01861 23.3214L7.60596 24.3478L8.14557 22.687L6.73291 21.6609H8.479L9.01861 20Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.01861 6.08691L9.5583 7.74777H11.3044L9.89166 8.77395L10.4313 10.4347L9.01861 9.40832L7.60596 10.4347L8.14557 8.77395L6.73291 7.74777H8.479L9.01861 6.08691Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.67096 13.9131L5.21064 15.5739H6.95666L5.544 16.6001L6.08369 18.2609L4.67096 17.2345L3.2583 18.2609L3.79791 16.6001L2.38525 15.5739H4.13127L4.67096 13.9131Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112566">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TokelauSvg;
